interface EnvironmentConfig {
  apiUrl: string;
  apiKey: string;
}

const environments: Record<'test' | 'production', EnvironmentConfig> = {
  test: {
    apiUrl: 'https://i6u5xcro82.execute-api.us-east-1.amazonaws.com/test',
    apiKey: 'XTiJ0DBDUZ1Y1BLSxpWyb7nPAvTO3IPJNluhekA0'
  },
  production: {
    apiUrl: 'https://jxqmj6uul2.execute-api.us-east-1.amazonaws.com/prod',
    apiKey: 'XTiJ0DBDUZ1Y1BLSxpWyb7nPAvTO3IPJNluhekA0'
  }
};

export const getEnvironmentConfig = (env: 'test' | 'production'): EnvironmentConfig => {
  return environments[env];
};